"use strict";

exports.__esModule = true;
exports.Meter = void 0;

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var now = window && window.performance ? window.performance.now.bind(window.performance) : Date.now || function () {
  return +new Date();
};

var Meter =
/*#__PURE__*/
function (_EventEmitter) {
  _inheritsLoose(Meter, _EventEmitter);

  function Meter(opts) {
    var _this;

    _this = _EventEmitter.call(this) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tick", function () {
      var time = now();
      var fps = time - _this.last;
      _this.ticks++;
      _this.last = time;
      _this.time += (fps - _this.time) * _this.options.decay;
      _this.rate = 1000 / _this.time;

      if (!(_this.ticks % _this.every)) {
        _this.emit('data', _this.rate);
      }
    });

    _this.options = {
      decay: 1,
      every: 1
    };
    Object.assign(_this.options, opts);
    _this.rate = 0;
    _this.time = 0;
    _this.ticks = 0;
    _this.last = now();
    return _this;
  }

  return Meter;
}(_eventemitter.default);

exports.Meter = Meter;